// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

import {REFRESH_MESSAGE} from './stores/constants';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export default function register() : Promise<any> {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(
      process.env.PUBLIC_URL!,
      window.location.toString()
  );
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      return Promise.resolve();
    }

    return new Promise((resolve)=>{
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

        if(!isLocalhost){
          // Is not local host. Just register service worker
          return resolve(registerValidSW(swUrl));
        } else {
          // This is running on localhost. Lets check if a service worker still exists or not.
          return resolve(checkValidServiceWorker(swUrl));
        }
      });
    })
  } else {
    return Promise.resolve('Content Loaded');
  }
}

function registerValidSW(swUrl: string) {
  return navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      return new Promise((resolve)=>{
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if(installingWorker){
            installingWorker.onstatechange = () => {
              if(installingWorker.state === 'installed'){
                if(navigator.serviceWorker.controller){
                  // At this point, the old content will have been purged and
                  // the fresh content will have been added to the cache.
                  // It's the perfect time to display a 'New content is
                  // available; please refresh.' message in your web app.
                  console.log(REFRESH_MESSAGE);
                  return resolve(REFRESH_MESSAGE);
                } else {
                  // At this point, everything has been precached.
                  // It's the perfect time to display a
                  // 'Content is cached for offline use.' message.
                  const MSG = 'Content is cached for offline use.';
                  console.log(MSG);
                  return resolve(MSG);
                }
              }
            };
          }
        }
      });
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
      return Promise.reject('Error during service worker registration');
    });
}

function checkValidServiceWorker(swUrl: string): Promise<any> {
  // Check if the service worker can be found. If it can't reload the page.
  return fetch(swUrl)
    .then((response) :Promise<any> => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (
        response.status === 404 ||
        response.headers.get('content-type')!.indexOf('javascript') === -1
    ) {
        // No service worker found. Probably a different app. Reload the page.
        return navigator.serviceWorker.ready.then(registration => {
          return registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        return registerValidSW(swUrl);
      }
    })
    .catch(() => {
      const MSG = 'No internet connection found. App is running in offline mode.';
      console.log(MSG);
      return Promise.reject(MSG)
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
